import React from 'react';
import './V1ExamPrograms.css';

interface V1ExamProgramsProps {
  theme: 'premium' | 'energetic';
}

const V1ExamPrograms: React.FC<V1ExamProgramsProps> = ({ theme }) => {
  const programs = [
    { title: 'Matura Podstawowa', description: 'Solidne fundamenty do zdania egzaminu' },
    { title: 'Matura Rozszerzona', description: 'Przygotowanie na najwyższym poziomie' },
    { title: 'Egzamin Ósmoklasisty', description: 'Start do dobrego liceum' }
  ];

  return (
    <section className="v1-exam-programs v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Programy Egzaminacyjne' : '🎯 PROGRAMY EGZAMINACYJNE'}
        </h2>

        <div className="v1-programs-grid">
          {programs.map((program, index) => (
            <div key={index} className="v1-program-card v1-glass v1-animate-in" style={{ animationDelay: `${0.2 + index * 0.1}s` }}>
              <h3>{program.title}</h3>
              <p>{program.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default V1ExamPrograms;
